import { useQuery } from '@apollo/client/react';
import type { VerifyEmbedQuery } from '@feature-request/app-graphql';
import { VerifyEmbedDocument } from '@feature-request/app-graphql';

type EmbedVerification = VerifyEmbedQuery['verifyEmbed'];

interface UseEmbedVerificationOptions {
	isEmbed: boolean;
	projectId: string;
	pageHmac: string;
	timestamp: string;
	embedOrigin: string;
}

export function useEmbedVerification({
	isEmbed,
	projectId,
	pageHmac,
	timestamp,
	embedOrigin,
}: UseEmbedVerificationOptions): {
	verification: EmbedVerification | null;
	verifying: boolean;
} {
	const { data, loading: verifying } = useQuery(VerifyEmbedDocument, {
		variables: {
			input: {
				projectId,
				pageHmac,
				timestamp,
				embedOrigin: embedOrigin || undefined,
			},
		},
		skip: !isEmbed || !projectId || !pageHmac || !timestamp,
		fetchPolicy: 'network-only',
	});

	return {
		verification: data?.verifyEmbed ?? null,
		verifying,
	};
}
